module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-300.d2c6a4b3.woff";